<template>
  <vxe-grid
    v-bind="gridOptions"
    :data="tableData"
    :columns="tableColumns"
    :span-method="mergeRowMethod"
    resizable
  >
  </vxe-grid>
</template>
<script>
import { request } from '@/api/service'
import tableColumns from './table-columns'
export default {
  props: {
    orderCode: String,
  },
  data() {
    return {
      gridOptions: {
        border: 'full',
        size: 'mini',
        toolbarConfig: {
          zoom: true,
        },
        seqConfig: {
          seqMethod: (params) => this.seqMethod(params),
        },
      },
      tableColumns: tableColumns(this),
      tableData: [],
    }
  },
  computed: {
    mergeCellByKey() {
      const mergeByKey = this.tableColumns.find((c) => c.mergeByKey)
      return mergeByKey ? mergeByKey.field : ''
    },
    mergeCell() {
      return this.tableColumns.filter((c) => c.merge).map((c) => c.field)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderCode) return
      request({
        url: '/factory/order/proofing/listByGoods',
        method: 'post',
        data: {
          orderCode: this.orderCode,
        },
      }).then((res) => {
        this.tableData = res.body.data
      })
    },
    // 通用行合并函数（将相同多列数据合并为一行）
    mergeRowMethod({ row, _rowIndex, column, visibleData }) {
      if (!this.mergeCellByKey) {
        return { rowspan: 1, colspan: 1 }
      }
      const fields = this.mergeCell
      const cellValue = row[this.mergeCellByKey]

      if (fields.includes(column.property)) {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        if (prevRow && prevRow[this.mergeCellByKey] === cellValue) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow[this.mergeCellByKey] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      }
    },
    seqMethod(params) {
      const { row, column, visibleData } = params
      const { property } = column
      if (property === 'orderProofingCode') {
        let group = []
        visibleData.forEach((i) => {
          if (group.indexOf(i.orderProofingCode) < 0) {
            group.push(i.orderProofingCode)
          }
        })
        return group.indexOf(row.orderProofingCode) + 1
      }
      const groupRow = visibleData.filter(
        (i) => i.orderProofingCode === row.orderProofingCode
      )
      return (
        groupRow.findIndex((i) => i.orderProofingGoodsCode === row.orderProofingGoodsCode) +
        1
      )
    },
  },
}
</script>